import { DateTime } from 'luxon';
// const zone = "Asia/Calcutta";
const getFirstMonday = () => {
  const date = new Date();
  const days = new Date(date.getFullYear(), date.getMonth(), 0).getDate();

  let mondays = new Date(
    '1' + '/' + date.getMonth() + 1 + '/' + date.getFullYear()
  ).getDay();
  if (mondays !== 1) {
    mondays = 9 - mondays;
  }
  mondays = [mondays];
  //console.log(mondays);
  for (let i = mondays[0] + 7; i <= days; i += 7) {
    mondays.push(i);
  }
  return mondays[0];
};
//next
const generateLocalTimingObj = (days, timings, zone) => {
  // initially all is empty
  const timeObj = {
    mon: [],
    tue: [],
    wed: [],
    thu: [],
    fri: [],
    sat: [],
    sun: [],
  };

  // will give user local date
  const date = new Date();

  // find first monday of current month and year because luxon need it
  let firstMonday = getFirstMonday();
  // ["mon"];

  // starting time conversion
  days.forEach((day, dayIndex) => {
    const newDay = firstMonday + dayIndex;

    timings[day].forEach((tm) => {
      const subTime = tm.split('-');

      const subTimeArray = [];

      let currentDayIndex;

      subTime.forEach((subTm) => {
        // const timeString = fullDate + "T" + subTm + gmt;
        console.log(subTm);
        const hr = parseInt(subTm.split(':')[0]);
        const min = parseInt(subTm.split(':')[1]);
        const timeString = DateTime.fromObject(
          {
            year: date.getFullYear(),
            month: date.getMonth() + 1,

            day: newDay,
            hour: hr,
            minute: min,
          },
          { zone }
        )
          .toLocal()
          .toString()
          .split('T')
          .pop();

        currentDayIndex =
          DateTime.fromObject(
            {
              year: date.getFullYear(),
              month: date.getMonth() + 1,
              day: newDay,
              hour: hr,
              minute: min,
            },
            { zone }
          ).toLocal().c.day - firstMonday;

        const time = timeString.split(':')[0] + timeString.split(':')[1];

        subTimeArray.push({ day: currentDayIndex, time: time });
        console.log(
          day,
          DateTime.fromObject(
            {
              year: date.getFullYear(),
              month: date.getMonth() + 1,
              day: newDay,
              hour: hr,
              minute: min,
            },
            { zone }
          ).toLocal().c.day,
          DateTime.fromObject(
            {
              year: date.getFullYear(),
              month: date.getMonth() + 1,
              day: newDay,
              hour: hr,
              minute: min,
            },
            { zone }
          ).toLocal().c.day - firstMonday,
          subTm,
          time
        );
      });

      // timeObj[days[currentDayIndex === -1 ? 6 : currentDayIndex]] = [
      //   ...timeObj[days[currentDayIndex === -1 ? 6 : currentDayIndex]],
      //   subTimeArray,
      // ];
      // spliting time between today and next day like (prev day) 23:00 - (next day) 00:30
      if (parseInt(subTimeArray[0].time) > parseInt(subTimeArray[1].time)) {
        const newArray1 = [subTimeArray[0].time, '2359'];
        const newArray2 = ['0000', subTimeArray[1].time];

        timeObj[days[subTimeArray[0].day === -1 ? 6 : subTimeArray[0].day]] = [
          ...timeObj[
            days[subTimeArray[0].day === -1 ? 6 : subTimeArray[0].day]
          ],
          newArray1,
        ];

        if (subTimeArray[1].time !== '0000') {
          timeObj[days[subTimeArray[1].day === -1 ? 0 : subTimeArray[1].day]] =
            [
              ...timeObj[
                days[subTimeArray[1].day === -1 ? 0 : subTimeArray[1].day]
              ],
              newArray2,
            ];
        }
      } else {
        const newArray = [subTimeArray[0].time, subTimeArray[1].time];
        timeObj[days[currentDayIndex === -1 ? 6 : currentDayIndex]] = [
          ...timeObj[days[currentDayIndex === -1 ? 6 : currentDayIndex]],
          newArray,
        ];
      }
    });
  });
  return timeObj;
};

export default generateLocalTimingObj;
